module.exports = __webpack_public_path__ + "img/Reviewed.6f861851.png";